module.exports = __webpack_public_path__ + "static/media/CT_2019_30457_pdf.7ff90574.pdf";